import React from 'react';
import styles from './RecentActivity.module.scss';
import ActivityItem from './activity-item/ActivityItem';
import { useFetch } from 'hooks/useFetch';
import { Agent } from 'hooks/endpoints';

const RecentActivity = () => {
  const { data } = useFetch(['recentActivities'], Agent.getRecentActivities, {
    enabled: true,
  });

  return (
    <div className={styles['recent-activity-container']}>
      <div className={styles['title-container']}>
        <p className={styles['title']}>Recent Activity</p>
        <p className={styles['subtitle']}>Latest updates across all bots</p>
      </div>
      <div className={styles['activity-list']}>
        {data?.data?.map((item, index) => (
          <ActivityItem data={item} key={index} />
        ))}
      </div>
    </div>
  );
};

export default RecentActivity;
